export const DENY_EVALUATION_PLAN = 'deny-evaluation-plan';
export const DUPLICATE_PLAN = 'duplicate-plan';
export const ARCHIVE_PLAN = 'archive-plan';
export const ASSIGNED_GROUPS = 'assigned-groups';
export const EVALUATION_SCORES = 'evaluation-scores';
export const EVALUATION_CRITERIA_LEGEND = 'evaluation-criteria-legend';
